<template>
    <div class="header-payment">
        <div class="header-div">
            <div class="title-div">
                <div class="icon-text-header">
                    <div class="icon-div">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="380"
                            height="380"
                            viewBox="0 0 480 480"
                            fill="none"
                            class="pattern"
                            opacity="0.4"
                        >
                            <defs>
                                <clipPath id="clip-circle">
                                    <rect x="190" y="190" width="240" height="240" />
                                </clipPath>
                            </defs>
                            <g clip-path="url(#clip-circle)">
                                <circle cx="240" cy="240" r="60" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="92" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="124" stroke="#E4E4E7" />
                                <circle cx="240" cy="240" r="156" stroke="#E4E4E7" />
                            </g>
                        </svg>
                        <vault-icon />
                    </div>
                    <header-email-verification @closeDialog="closeDialog" />
                </div>
                <div class="title-wrapper">
                    <main-email-verification ref="mainEmailVerificationRef" @update:otpValue="handleOtpValue" @enterPressed="handleEnterPressed" />
                </div>
            </div>
        </div>
    <footer-email-verification ref="footerRef" @closeDialog="closeDialog" :otpValue="otpValue" @resetEmailSent="handleResetEmailSent" />
    </div>
</template>
<script setup lang="ts">
import VaultIcon from '~/assets/images/icons/vault-icon.svg';
import { ModalNames } from '~/types/modals';
import FooterEmailVerification from './FooterEmailVerification.vue';
import HeaderEmailVerification from './HeaderEmailVerification.vue';
import MainEmailVerification from './MainEmailVerification.vue';


const dialogRef = getDialogRef(ModalNames.EMAIL_VERIFICATION);
const otpValue = ref('');
const footerRef = ref();

const closeDialog = () => {
    dialogRef.value.close();
};

const handleOtpValue = (value: string) => {
    otpValue.value = value;
};

const mainEmailVerificationRef = ref();

const handleEnterPressed = () => {
    if (footerRef.value && footerRef.value.verifyOtp) {
        footerRef.value.verifyOtp();
    }
};

const handleResetEmailSent = () => {
    // Access MainEmailVerification and set isEmailSent to false
    if (mainEmailVerificationRef.value && mainEmailVerificationRef.value.isEmailSent !== undefined) {
        mainEmailVerificationRef.value.isEmailSent = false;
    }
};
</script>
<style lang="scss" scoped>
.header-payment {
    @apply sm:max-w-xl w-11/12 rounded-lg bg-white mx-auto h-auto;

    .header-div {
        @apply flex items-start gap-4 self-stretch p-6 bg-white rounded-t-lg;

        .content-wrapper {
            @apply items-start gap-1 flex-1 flex flex-col;
        }
    }

    .icon-div {
        @apply relative flex w-12 h-12 p-3 justify-center items-center rounded-full bg-gray-100;

        .pattern {
            @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none;
        }
    }
}
.title-div {
    @apply flex flex-col items-start gap-1 self-stretch w-full;
}
.icon-text-header{
    @apply flex flex-row items-start gap-4 items-start w-full ;
}
.title-wrapper {
    @apply flex flex-col items-start gap-1 sm:flex-1 sm:w-auto w-full sm:pl-16;
}
</style>
